import {Component} from '@angular/core';

@Component({
    selector: 'blitz-basic-script-canvas',
    templateUrl: 'canvas.html'
    //styleUrls: ['blitz-basic-script.scss']
})
export class CanvasComponent {
    constructor() {

    }
}
